(function () {
  const root = document.querySelector("article-content .rte, .article-content .rte");
  if (!root) return;

  const links = root.querySelectorAll('a[href*="/products/"]');
  links.forEach((link) => {
    if (link.closest(".mn-product-embed") || link.closest(".mn-product-card")) return;
    const image = link.querySelector("img");
    if (!image) return;

    link.classList.add("mn-product-embed");
    if (!link.querySelector(".mn-product-cta")) {
      const cta = document.createElement("span");
      cta.className = "mn-product-cta";
      cta.textContent = "Ürünü incele";
      link.appendChild(cta);
    }
  });
})();
